<template>
  <footer class="main-footer  container">
    <div class="main-footer__inner  container-inner">
      <div class="main-footer__content">

        <div class="main-footer__col main-footer__col--menus">
          <div class="main-footer__menus">
            <FooterMenu class="main-footer__menu"
                        :name="$tFooter('Menu')"
                        :menu="menu"/>
<!--            <FooterMenu class="main-footer__menu"-->
<!--                        :name="$tFooter('Our services')"-->
<!--                        :menu="servicesMenu"/>-->
          </div>
        </div>

        <div class="main-footer__col main-footer__col--params">
          <div class="main-footer__currency-and-languages">
            <FooterCurrencySelect/>
            <FooterLanguagesSelect/>
          </div>
          <router-link-modified :to="{name: 'auth-employer'}"
                                class="main-footer__auth-link  base-btn  base-btn--outline-blue">
            {{ $tFooter('For employers') }}
          </router-link-modified>
          <router-link-modified :to="{name: 'auth-agent'}"
                                class="main-footer__auth-link  base-btn  base-btn--outline-green">
            {{ $tFooter('For agents') }}
          </router-link-modified>
        </div>

        <div class="main-footer__col main-footer__col--contacts">
          <TabsBlock v-if="supportByCountries.length"
                     :tabs="supportByCountries"
                     class="main-footer__tabs-block">
            <!---->
            <template v-slot:tab="{tab}">{{ tab.country_name_translations[currentLocale] }}</template>
            <template v-slot:content="{tab}">
              <div class="main-footer__contact">
                <h5 class="main-footer__contact-title">{{ $tFooter('Hotline') }}</h5>
                <a v-for="phone in tab.phones"
                   :key="phone"
                   :href="phone | toLinkPhone"
                   target="_blank"
                   class="main-footer__contact-item">
                  {{ formatPhone(phone) }}
                </a>
              </div>
            </template>
            <!---->
          </TabsBlock>
          <Socials :list="socialsChannels"
                   class="main-footer__socials"/>
        </div>
      </div>
      <div class="main-footer__bottom">
        <p class="main-footer__copyright">
          {{ $tFooter('All rights reserved') }} {{ currentYear }} ©
        </p>
      </div>
    </div>

    <a v-if="isLogged && user"
       :href="'https://jobian-ai.whiteweb.com.ua/'+ user.id"
       target="_blank"
       class="hidden-link">&nbsp;</a>
  </footer>
</template>

<script>
  import formatPhone from '@/helpers/formatPhone'
  import FooterLanguagesSelect from '../components/FooterLanguagesSelect'
  import FooterCurrencySelect from '../components/FooterCurrencySelect'
  import TabsBlock from "./TabsBlock";
  import FooterMenu from "./FooterMenu";
  import Socials from "./Socials";
  // import SocialsContacts from "./SocialsContacts";

  export default {
    components: {
      FooterMenu,
      TabsBlock,
      FooterLanguagesSelect,
      FooterCurrencySelect,
      Socials,
      // SocialsContacts
    },
    data() {
      return {
        pending: false,
        menu: globalConfigs.footer.menu,
        servicesMenu: globalConfigs.footer.our_services,
        socialsChannels: globalConfigs.footer.channels,
        contactVia: globalConfigs.footer.contact_via,
        supportByCountries: globalConfigs.footer.support_by_countries,
        currentYear: (new Date().getFullYear())
      }
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      user() {
        return this.$store.state.user.profile
      },
      currentLocale() {
        return this.$store.state.currentLocale
      }
    },
    methods: {
      formatPhone: formatPhone,
    }
  }
</script>

<style lang="less">

  footer {
    position: relative;
  }

  .hidden-link {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 0;
    bottom: 0;
  }

</style>
